// Funzione per creare l'ID unico per ogni h2
const createUniqueId = (text) => {
    return text.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
};

// Funzione per creare l'indice
const createTableOfContents = () => {
    const content = document.querySelector('.pathology-content');
    const indexContainer = document.querySelector('.pathology-content__index');
    const headers = content.querySelectorAll('h2');

    if (headers.length === 0 || !indexContainer) return;

    const ul = document.createElement('ul');

    headers.forEach((header, index) => {
        // Crea un ID unico per l'h2 se non ne ha già uno
        if (!header.id) {
            header.id = `${createUniqueId(header.textContent)}-${index + 1}`;
        }
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${header.id}`;
        a.textContent = header.textContent;
        li.classList.add('lh-sm');
        li.appendChild(a);

        // Aggiungi evento click per lo scroll preciso e la chiusura dell'accordion
        a.addEventListener('click', (event) => {
            event.preventDefault();

            // Calcola l'offset dell'header
            let headerOffset = 0;
            if (window.innerWidth > 1200) {
                headerOffset = document.querySelector(".site-header__middle-bar").offsetHeight;
            } else {
                headerOffset = document.querySelector(".site-header").offsetHeight + 50 ;
            }

            // Controlla se l'accordion è aperto prima di aggiungere il suo offset
            const accordionElement = document.querySelector('#flush-index');
            if (accordionElement && accordionElement.classList.contains('show')) {
                headerOffset += 80;
                accordionElement.classList.remove('show');
                const accordionButton = document.querySelector('[data-bs-target="#flush-index"]');
                accordionButton.classList.add('collapsed');

            }

            // Calcola la posizione dell'elemento target e applica l'offset
            const target = document.querySelector(`#${header.id}`);
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            // Scrolla alla posizione
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });

        });

        indexContainer.appendChild(li);
    });
};

const pathologyIndex = () => {
    createTableOfContents();
};

export default pathologyIndex;
